import React from 'react';
import {AppBar, IconButton, Tooltip} from "@material-ui/core";
import AccountCircle from '@material-ui/icons/AccountCircle';
import ExitToApp from '@material-ui/icons/ExitToApp';
import CssBaseline from '@material-ui/core/CssBaseline';

import Toolbar from '@material-ui/core/Toolbar';
//import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/core/styles';
import {logout} from '../../redux/user';
import {useDispatch} from 'react-redux';

import {useRouteMatch, Switch, Route, Redirect} from "react-router-dom";

import PollLandingPage from '../polls/PollLandingPage';
import EditPoll from '../polls/EditPoll';
import Container from "@material-ui/core/Container";
import {PrivateRoute} from "../../App"
import {DEFAULT_PAGE, POLL_PAGE} from '../../constants/app-constants';


const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
    color: 'white'
  },
  leftIcon: {
    color: 'white'
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  mainText: {
    ...theme.typography.h5,
    flexGrow: 1,
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  appBar: {
    marginBottom: '1em'
  }
}));


export default function MainLayout() {
  const classes = useStyles();
  const dispatch = useDispatch();

  let {path} = useRouteMatch();


  return (
    <React.Fragment>
      <CssBaseline/>
      <AppBar position="sticky" className={classes.appBar}>
        <Toolbar>
          <AccountCircle className={classes.icon}/>
          <div className={classes.mainText}>
            Кабінет здобувача освіти
          </div>

          <Tooltip title="Вихід">
            <IconButton onClick={() => dispatch(logout())}>
              <ExitToApp className={classes.leftIcon}/>
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>
      <Container component="main" maxWidth="lg">
        <Switch>
          <PrivateRoute exact path={path}>
            <PollLandingPage/>
          </PrivateRoute>
          <PrivateRoute path={`${path}${POLL_PAGE}/:pollId`}>
            <EditPoll />
          </PrivateRoute>
          <Route>
            <Redirect to={{pathname: DEFAULT_PAGE}}/>
          </Route>
        </Switch>
      </Container>
    </React.Fragment>
  )

}